import React from 'react'
import NewsCarousel from '../newsCarousel'
import PropTypes from 'prop-types'
import { FaAngleDown, FaAngleRight } from 'react-icons/fa'
import { Collapse } from 'reactstrap'
import { fetchNews } from '../../../service/newsService'
import { setItem as setItemInLocalStorage, getItem as getItemInLocalStorage, constants as LocalStorageConstants } from '../../../localStorage/localStorageManager'
import Loading from '../loading'

/** Le news button contiendra le carousel et permettra de dérouler les différentes news */
export default class NewsButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapse: true,
            loading: false,
            isOpen: false
        }
    }

    toggleModal = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    collapse = () => {
        this.setState({ collapse: !this.state.collapse })
    }

    /** Lors de la création du composant, on va rechercher les news.
     * S'il n'y en a pas, alors on renvoi un tableau vide
     */
    componentDidMount = () => {
        this.setState({ loading: true })
        this.props.newsToState(getItemInLocalStorage(LocalStorageConstants.LOCAL_STORAGE_NEWS))
        fetchNews() // axios
            .then(({ data }) => {
                // Une réponse est reçue, on a accès à internet
                this.props.newsToState(data) // Redux set news
                setItemInLocalStorage(LocalStorageConstants.LOCAL_STORAGE_NEWS, data) // Local storage set news
            })
            .catch(error => {
                // Pas de réponse, soit le TOKEN n'est plus valide, soit nous n'avons pas d'accès réseau
                // Dans ce cas, ce qui est dans le local storage sera affiché
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    render() {
        return (
            <div className="news-buttons text-center">
                {/** Collapse */}
                <div className="container-fluid news-head">
                    <div className="col-1"> {!this.state.collapse ? <FaAngleRight className="news-collapser" onClick={this.collapse} /> : <FaAngleDown className="news-collapser" onClick={this.collapse} />}</div>
                    <div className="col-8 offset-1"><h2 className="news-title">News</h2></div>
                    <div className="col-1">{this.state.loading && <Loading />}</div>
                </div>
                <div onClick={this.toggleModal}>
                <Collapse isOpen={this.state.collapse}>
                    {/** Carousel */}
                    <NewsCarousel news={this.props.news} toggleModal={this.toggleModal} modal={this.state.isOpen} />
                </Collapse>
                </div>
            </div>
        )
    }
}

NewsButton.propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape({
        GUID: PropTypes.string,
        Title: PropTypes.string,
        Contenu: PropTypes.string,
        Created: PropTypes.string,
        Image: PropTypes.shape({
            Description: PropTypes.string,
            Url: PropTypes.string
        })
    })),
    newsToState: PropTypes.func
}